<form [formGroup]="form" (ngSubmit)="create()">
  <h1 mat-dialog-title [translate]="dialogTitle"></h1>
  <mat-dialog-content>
    <mat-form-field>
      <mat-label translate="common/name"></mat-label>
      <input type="text" matInput formControlName="name" />
      <mat-error *ngIf="form.controls.name.errors?.required" translate="common/form_errors/required"></mat-error>
    </mat-form-field>

    <div>
      <div class="alc-label-text"><span translate="audience/optin_date_range"></span></div>
      <div>{{ data.massMessaging.rangeString }}</div>
    </div>

    <div class="alc-margin-top-16">
      <div class="alc-label-text"><span translate="audience/account_name"></span></div>

      <ng-container *ngFor="let site of data.audienceDropdownItems.sites">
        <ng-container *ngFor="let account of data.massMessaging.audience_filters.accounts">
          <app-site-icon-and-name
            *ngIf="account === site.id"
            [item]="{ type: site.type, isGroup: false, typeName: site.typeName }">
            {{ site.label }}
          </app-site-icon-and-name>
        </ng-container>
      </ng-container>
    </div>

    <div class="alc-margin-top-16">
      <div class="alc-label-text"><span translate="segment"></span></div>

      <ng-container *ngFor="let segment of data.audienceDropdownItems.segments">
        <div *ngIf="data.massMessaging.audience_filters.segment === segment.id">{{ segment.label }}</div>
      </ng-container>
    </div>

    <mat-form-field>
      <mat-label translate="mass_messaging/scenario_and_entrypoint"></mat-label>
      <mat-select formControlName="entrypointId" data-testid="scenario-select">
        <mat-optgroup *ngFor="let item of data.massMessagingEntrypointsDropdownItems" [label]="item.label">
          <mat-option *ngFor="let subitem of item.subitems" [value]="subitem.id">
            {{ subitem.label }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <mat-checkbox formControlName="is_test">
      <span translate="audience/testing"></span>
    </mat-checkbox>
  </mat-dialog-content>

  <app-date-time-schedule-modal
    *ngIf="displayDateTimeModal"
    [dateTime]="data.massMessaging.scheduledTime"
    modalTitleKey="mass_messaging/schedule_new"
    confirmBtnTextKey="mass_messaging/creation-edition/schedule"
    (closeModal)="closeDateTimeModal($event)"></app-date-time-schedule-modal>

  <mat-dialog-actions align="end">
    <button
      mat-raised-button
      type="button"
      color="primary"
      (click)="schedule()"
      [disabled]="disableEdition || form.invalid"
      data-testid="schedule-button">
      <span translate="mass_messaging/creation-edition/schedule"></span>
    </button>
    <button
      mat-raised-button
      type="submit"
      color="primary"
      [disabled]="disableEdition || form.invalid"
      data-testid="create-button">
      <span translate="mass_messaging/creation-edition/create"></span>
    </button>
    <button mat-raised-button type="button" (click)="cancel()"><span translate="cancel"></span></button>
  </mat-dialog-actions>
</form>
